export const DeleteDDSFile = async (fileId: number) => {
	let url = `/api2.0/CANDDS/Delete/${fileId}`;
	let options = {
		method: 'GET', // this should be DELETE instead of GET
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
		},
	};
	const response = await fetch(url, options);
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return response;
};
